import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toHandlerKey as _toHandlerKey, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5eaa662f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "side-menu",
  ref: "menu"
}
const _hoisted_2 = { class: "screen-reader" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bar" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bar" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bar" }, null, -1))
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FloatingActionButton = _resolveComponent("FloatingActionButton")!
  const _component_LogoMain = _resolveComponent("LogoMain")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FloatingActionButton, {
      onClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggle()))
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          (_ctx.closed)
            ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_3, null, 512)), [
                [_directive_translate, `general.menu_open`]
              ])
            : _createCommentVNode("", true),
          (!_ctx.closed)
            ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, null, 512)), [
                [_directive_translate, `general.menu_close`]
              ])
            : _createCommentVNode("", true)
        ]),
        _hoisted_5,
        _hoisted_6,
        _hoisted_7
      ]),
      _: 1
    }),
    _createElementVNode("nav", null, [
      _createVNode(_component_LogoMain),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            (item.name)
              ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: { name: item.name, params: { lang: _ctx.$i18n.locale } }
                }, null, 8, ["to"])), [
                  [_directive_translate, item.text]
                ])
              : (item.action)
                ? _withDirectives((_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: "javascript:void(0);",
                    [_toHandlerKey(_ctx.bindAction(item))]: ($event: any) => (item.action(this))
                  }, null, 16)), [
                    [_directive_translate, item.text]
                  ])
                : (item.url)
                  ? _withDirectives((_openBlock(), _createElementBlock("a", {
                      key: 2,
                      target: "_blank",
                      href: this.getItemUrl( item )
                    }, null, 8, _hoisted_8)), [
                      [_directive_translate, item.text]
                    ])
                  : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ], 512))
}